import Vue from "vue";
import { BootstrapVue} from "bootstrap-vue/dist/bootstrap-vue.esm";

Vue.config.performance = true;

Vue.use(BootstrapVue);

import App from "./TermsAndConditions.vue";

new Vue({
render: (h) => h(App),
}).$mount("#app");